// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1Wbl2","sidebar__item":"Sidebar_sidebar__item__2624W"};